import * as React from "react";
import ReCAPTCHA from "react-google-recaptcha";

type CCMReCaptchaProps = {
    siteKey: string;
    onChange: (value: string) => void;
};

export default ({ siteKey, onChange }: CCMReCaptchaProps) => {

    return (
        <div className="form-g-recaptcha">
            <ReCAPTCHA
                sitekey={siteKey}
                onChange={onChange}
            />

            <div
                className="g-recaptcha"
                data-sitekey={siteKey}
                data-callback="onSubmitCallback"
            />
        </div>
    );
};
